// Simple performance monitoring utility
class PerformanceMonitor {
  constructor() {
    this.memorySnapshots = [];
    this.maxSnapshots = 10;
  }

  // Take a memory snapshot
  takeMemorySnapshot(label = '') {
    if (performance.memory) {
      const snapshot = {
        timestamp: Date.now(),
        label,
        usedJSHeapSize: performance.memory.usedJSHeapSize,
        totalJSHeapSize: performance.memory.totalJSHeapSize,
        jsHeapSizeLimit: performance.memory.jsHeapSizeLimit
      };
      
      this.memorySnapshots.push(snapshot);
      
      // Keep only the last N snapshots
      if (this.memorySnapshots.length > this.maxSnapshots) {
        this.memorySnapshots.shift();
      }
      
      // Log if memory usage is high
      const usedMB = snapshot.usedJSHeapSize / 1024 / 1024;
      if (usedMB > 1000) { // 1GB threshold
        console.warn(`High memory usage detected: ${usedMB.toFixed(2)}MB`, snapshot);
      }
      
      return snapshot;
    }
    return null;
  }

  // Get current memory usage
  getCurrentMemoryUsage() {
    if (performance.memory) {
      return {
        used: performance.memory.usedJSHeapSize / 1024 / 1024,
        total: performance.memory.totalJSHeapSize / 1024 / 1024,
        limit: performance.memory.jsHeapSizeLimit / 1024 / 1024
      };
    }
    return null;
  }

  // Clear snapshots
  clearSnapshots() {
    this.memorySnapshots = [];
  }

  // Get memory trend
  getMemoryTrend() {
    if (this.memorySnapshots.length < 2) return 'insufficient_data';
    
    const first = this.memorySnapshots[0];
    const last = this.memorySnapshots[this.memorySnapshots.length - 1];
    const diff = last.usedJSHeapSize - first.usedJSHeapSize;
    
    if (diff > 50 * 1024 * 1024) return 'increasing'; // 50MB increase
    if (diff < -50 * 1024 * 1024) return 'decreasing'; // 50MB decrease
    return 'stable';
  }
}

// Create singleton instance
const performanceMonitor = new PerformanceMonitor();

// Auto-monitor memory usage every 30 seconds
setInterval(() => {
  performanceMonitor.takeMemorySnapshot('auto-monitor');
}, 30000);

export default performanceMonitor; 